import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Dayjs } from 'dayjs';
import 'dayjs/locale/ru';
import TextField from '@mui/material/TextField';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { COLLECT_STATUS_CONFIG } from '../../../../constants';
import { CollectStatus } from '../../../../types';
import * as Styled from './StatusPanels.styles';

interface ExpiryPanelProps {
  onConfirm: (expDate: string) => void;
  onCancel: () => void;
}

const config = COLLECT_STATUS_CONFIG[CollectStatus.EXPIRY];

const ExpiryPanel = ({ onConfirm, onCancel }: ExpiryPanelProps) => {
  const { t } = useTranslation();
  const [value, setValue] = useState<Dayjs | null>(null);
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const isValid = Boolean(value && value.isValid());

  return (
    <Styled.PanelContainer
      accentColor={config.color}
      accentBackground={config.background}
      accentBorder={config.border}
    >
      <div className="panel-title">
        {t('OrderPage.Collect.ExpiryModal.TITLE')}
      </div>
      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ru">
        <DatePicker
          views={['year', 'month']}
          openTo="month"
          disablePast
          open={isOpen}
          onOpen={() => setIsOpen(true)}
          onClose={() => setIsOpen(false)}
          value={value}
          onChange={(newValue) => setValue(newValue as Dayjs | null)}
          inputFormat="MM.YYYY"
          renderInput={(params) => (
            <TextField
              {...params}
              fullWidth
              size="small"
              placeholder={t('OrderPage.Collect.ExpiryModal.PLACEHOLDER')}
              onClick={() => setIsOpen(true)}
              inputProps={{ ...params.inputProps, readOnly: true }}
              sx={{ '& .MuiInputBase-root': { cursor: 'pointer' } }}
            />
          )}
        />
      </LocalizationProvider>
      <div className="panel-hint">
        {t('OrderPage.Collect.ExpiryModal.HINT')}
      </div>
      <div className="panel-actions">
        <button
          type="button"
          className="panel-button cancel"
          onClick={onCancel}
        >
          {t('OrderPage.Collect.ExpiryModal.CANCEL')}
        </button>
        <button
          type="button"
          className="panel-button confirm"
          style={{ background: config.color }}
          disabled={!isValid}
          onClick={() => value && onConfirm(value.format('MM.YYYY'))}
        >
          {t('OrderPage.Collect.ExpiryModal.CONFIRM')}
        </button>
      </div>
    </Styled.PanelContainer>
  );
};

export default ExpiryPanel;
